<template>
  <el-dialog title="新增日志" :visible.sync="addVisible" width="550px" :show-close="true" class="add text-center" append-to-body>
    <div class="p-20 text-left" style="padding-bottom: 10px;">
      <el-form ref="form">
        <el-form-item>
          <div class="flex">
            <el-input class="flex-1 font-12-30313a" type="textarea" placeholder="请输入日志内容" v-model="addContent" resize="none"></el-input>
          </div>
        </el-form-item>
      </el-form>
      <el-upload
        class="text-left"
        multiple
        name="file"
        :httpRequest="httpRequestImg"
        :action="upload"
        :show-file-list="false"
        :before-upload="beforeImgUpload">
        <div class="addBtn cursor mb-10 button">
          <img src="/static/images/customer/chubeikehu.png" alt="">
          <div>上传图片</div>
        </div>
      </el-upload>
      <div class="flex flex-wrap ">
        <div class="picItem mr-10 mb-10 relative" v-for="(item, index) in addPic" :key="index">
          <viewer :images="addPic">
            <img :src="Utils.IMG_PREV + item.path" alt="" fit="cover" style="width: 100%; height: 100%;">
          </viewer>
          <!--<el-image :src="Utils.IMG_PREV + item.path" alt="" fit="cover" style="width: 100%; height: 100%;"></el-image>-->
          <img src="/static/images/removeImg.png" class="absolute removeIcon" alt="" @click="removePic(index)">
        </div>
      </div>
    </div>
    <div slot="footer">
      <div class="btn-30-bd-85-s mr-10" @click="onClose">取消</div>
      <div class="btn-30-bg-f5971d-s" @click="onSubmit">确定</div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'AddLog',
  components: {},
  props: ['detailItem'],
  data () {
    return {
      addVisible: false,
      upload: `${this.$store.state.API_URL_9009}/fileUpload/uploadFile`,
      addContent: null,
      addPic: []
    }
  },
  created () {},
  mounted () {},
  methods: {
    beforeImgUpload () {},
    httpRequestImg (e) {
      let formData = new FormData()
      formData.append('fileData', e.file)
      formData.append('type', 4)
      this.axios.post(`${this.$store.state.API_URL_9009}/fileUpload/uploadFile`, formData, {
        headers: {
          'type': 'web_emp',
          'Content-Type': 'multipart/form-data',
          'token': this.$store.state.token
        }
      }).then(onloadRes => {
        if (onloadRes.data.success) {
          this.addPic.push({path: onloadRes.data.data.path})
        }
      }).catch(() => {
        this.$message.error('上传失败3！')
      })
    },
    removePic (index) {
      this.addPic.splice(index, 1)
    },
    onClose () {
      this.addContent = ''
      this.addPic = []
      this.addVisible = false
    },
    onSubmit () {
      this.axios.post(`orderLog/save`, {
        orderId: this.detailItem.id,
        content: this.addContent,
        logPhotoParamList: this.addPic
      }).then(res => {
        if (res.data.success) {
          this.$message({
            message: '保存成功',
            type: 'success'
          })
          this.$parent.$parent.getData()
          this.onClose()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .add /deep/ .el-textarea__inner{
    padding-left: 10px;
    padding-right: 10px;
    height: 120px;
  }
  .addBtn{
    background: #fff;
    width: 85px;
    height: 24px;
    color: #30313a;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    border-radius: 4px;
  }
  .button{
    border: 1px solid #e2e2e2;
  }
  .picItem{
    width: 70px;
    height: 70px;
  }
  .removeIcon{
    top:5px;
    right: 5px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/pages/order/components/AddLog.vue